module.exports = __webpack_public_path__ + "static/media/README.9f9a30f2.md";